const dict = {
  uk: {
    students: {
      loadingStudents: 'Завантаження студентів…',
      loading: 'Завантаження…',
      noStudents: 'У вас поки немає студентів.',
      searchPlaceholder: 'Пошук студента…',
      nothingFound: 'Нічого не знайдено',
      pickStudent: 'Оберіть студента зі списку',
      backToList: 'До списку',
      noName: 'Без імені',
      noProgram: 'Без програми',
      ageYears: '{{age}} р.',
      failedToLoad: 'Не вдалося завантажити',
      failedToLoadList: 'Не вдалося завантажити список',
      // sections
      preferences: 'Вподобання',
      preferencesEmpty: "Поки що немає записів. Додайте, щоб пам'ятати, що любить студент.",
      preferencesPlaceholder: 'Що подобається студенту? Улюблені теми, персонажі, ігри, хобі…',
      addPreferences: 'Додати',
      editPreferences: 'Редагувати',
      failedToSave: 'Не вдалося зберегти',
      programs: 'Програми',
      noPrograms: 'Студент не має програм у вас.',
      programStart: 'Початок: {{date}} · Пройдено {{done}} з {{total}} уроків',
      extraLessons: 'Додаткові уроки ({{count}})',
      noExtraLessons: 'Спеціальних уроків, повторень чи власних презентацій з цим студентом ще не було.',
      noExtraLessonsOfType: 'Немає уроків цього типу.',
      extraFilterAll: 'Всі',
      extraFilterSpecial: 'Спеціальні',
      extraFilterRepetition: 'Повторення',
      extraFilterCustom: 'Власні',
      extraTypeSpecial: 'Спеціальний',
      extraTypeRepetition: 'Повторення',
      extraTypeCustom: 'Власна презентація',
      extraPlanned: 'Заплановано',
      extraWithTeacher: 'з {{name}}',
      upcomingLessons: 'Найближчі уроки ({{count}})',
      noUpcomingLessons: 'Запланованих уроків поки немає.',
      showAllUpcoming: 'Показати ще ({{count}})',
      collapseUpcoming: 'Згорнути',
      completedLessons: 'Пройдені уроки ({{count}})',
      noCompletedLessons: 'Ще немає пройдених уроків.',
      colDate: 'Дата',
      colTopic: 'Тема',
      colProgram: 'Програма',
      colStars: 'Зірочки',
      homeworkSection: 'Домашні завдання ({{count}})',
      noHomework: 'Поки немає ДЗ.',
      colHomework: 'ДЗ',
      colStatus: 'Статус',
      colDetails: 'Деталі',
      colTest: 'Тест',
      colResult: 'Результат',
      moduleTests: 'Модульні тести ({{count}})',
      noModuleTests: 'Модульних тестів поки немає.',
      repetitionGames: 'Ігри на повторення ({{count}})',
      noGames: 'Ігор для цих програм ще немає.',
      lessonFallback: 'Урок',
      lessonUnlocked: 'Відкрито',
      lessonNotPassed: 'Урок не пройдено',
      // homework
      homeworkFallback: 'ДЗ',
      lessonIndex: 'Урок {{index}} · {{date}}',
      pointsScore: '{{score}}/{{max}} балів',
      dueBy: 'до {{date}}',
      sending: 'Надсилаю…',
      sendHomework: 'Надіслати',
      viewShort: 'Переглянути',
      viewSubmission: 'Переглянути роботу',
      failedToSendHomework: 'Не вдалося надіслати ДЗ',
      // module tests
      moduleTestFallback: 'Модульний тест',
      attemptNumber: 'Спроба #{{n}}',
      passed: 'Складено',
      failed: 'Не складено',
      scoreDetails: '{{score}}/{{max}} балів · {{pct}}% (поріг {{passing}}%)',
      scoreDetailsNoPct: '{{score}}/{{max}} балів (поріг {{passing}}%)',
      viewMistakes: 'Переглянути помилки',
      // games
      attempts: '{{count}} спроб',
      statusLocked: 'Заблоковано',
      statusAvailable: 'Відкрито',
      statusCompleted: 'Пройдено',
      // game type labels
      gameTypeMemory: 'Memory',
      gameTypeLabelledDiagram: 'Labelled Diagram',
      gameTypePairOrNoPair: 'Pair or No Pair',
      gameTypeListenType: 'Listen & Type',
      gameTypeListenPickImage: 'Listen & Pick',
      gameTypeDictation: 'Диктант',
      // homework statuses
      hwStatusNotSent: 'Не надіслано',
      hwStatusSent: 'Надіслано',
      hwStatusOverdue: 'Прострочено',
      hwStatusSubmitted: 'Здано',
      hwStatusSubmittedLate: 'Здано з запізненням',
      // module test statuses
      mtStatusNotSent: 'Не надіслано',
      mtStatusSent: 'Надіслано',
      mtStatusOverdue: 'Прострочено',
      mtStatusPending: 'Не розпочато',
      mtStatusInProgress: 'У процесі',
      mtStatusSubmitted: 'Здано',
      mtStatusSubmittedLate: 'Здано з запізненням',
      mtStatusGraded: 'Оцінено',
      sendModuleTest: 'Надіслати',
      failedToSendModuleTest: 'Не вдалося надіслати модульний тест',
      timeTaken: 'Час проходження',
    },
    leavePanel: {
      title: 'Відпустки та лікарняні',
      submitRequest: 'Подати заявку',
      loading: 'Завантаження…',
      confirmCancel: 'Скасувати цю заявку?',
      historyTitle: 'Історія заявок',
      noRequests: 'Заявок ще немає.',
      cancelRequest: 'Скасувати',
      vacationCard: 'Відпустка',
      sickCard: 'Лікарняний ({{year}})',
      forceMajeureCard: 'Форсмажор (цього місяця)',
      dayOffCard: 'Вихідний (цього місяця)',
      daysUnit: 'дн.',
      capOf: '/ {{cap}} дн.',
      capOfShort: '/ {{cap}}',
      vacationDetails: 'Нараховано: {{accrued}} дн., використано: {{used}} дн.',
      firstLesson: 'Перший урок: {{date}}',
      noticeDays: 'Подавати щонайменше за {{days}} днів.',
      sickDetails: 'Використано: {{used}} дн. цього року.',
      forceMajeureDetails: 'Використано: {{used}}/{{cap}} дн. цього місяця. Невикористані згорають.',
      dayOffDetails: 'Використано: {{used}}/{{cap}} вихідних цього місяця.',
      rejectionReason: 'Причина відмови: {{reason}}',
      statusPending: 'Очікує розгляду',
      statusApproved: 'Схвалено',
      statusRejected: 'Відхилено',
      statusCancelled: 'Скасовано',
    },
    workingHours: {
      buttonLabel: 'Робочі години',
      title: 'Робочі години',
      pastDate: 'Минула дата',
      customSchedule: 'Індивідуальний розклад',
      applyToEvery: 'Застосувати до кожного {{day}}',
      applyToAllDays: 'Застосувати до кожного дня тижня',
      changesOnlyFor: 'Зміни будуть застосовані тільки до {{date}}',
      legendAvailable: 'Не робочий час',
      legendWorking: 'Робочий час',
      legendBusy: 'Є урок',
      legendPast: 'Минуло',
      cancel: 'Скасувати',
      saving: 'Збереження...',
      save: 'Зберегти',
      alertWarningTitle: 'Увага',
      alertWarningSomeFailed: 'Деякі зміни не вдалося зберегти',
      alertSuccessTitle: 'Успішно',
      alertSavedAllWeeks: 'Робочі години збережено для всіх тижнів',
      alertSavedForDate: 'Робочі години збережено для {{date}}',
      alertErrorTitle: 'Помилка',
      alertErrorSave: 'Не вдалося зберегти зміни',
      // day names (used in "apply to every {{day}}" — lowercased)
      daySunday: 'Неділя',
      dayMonday: 'Понеділок',
      dayTuesday: 'Вівторок',
      dayWednesday: 'Середа',
      dayThursday: 'Четвер',
      dayFriday: "П'ятниця",
      daySaturday: 'Субота',
      // months (genitive form used in date rendering)
      monthJan: 'січня',
      monthFeb: 'лютого',
      monthMar: 'березня',
      monthApr: 'квітня',
      monthMay: 'травня',
      monthJun: 'червня',
      monthJul: 'липня',
      monthAug: 'серпня',
      monthSep: 'вересня',
      monthOct: 'жовтня',
      monthNov: 'листопада',
      monthDec: 'грудня',
    },
    assignSpecial: {
      titleSpecial: 'Призначити спеціальний урок',
      titleRepetition: 'Призначити урок повторення',
      tabSpecial: 'Спеціальні',
      tabRepetition: 'Повторення',
      tabCustom: 'Власний',
      loading: 'Завантаження...',
      selectLessonError: 'Оберіть урок',
      customCategoryMissing: 'Категорія для власних уроків не знайдена',
      assignError: 'Помилка призначення уроку',
      specialEmpty: 'Для цієї програми ще не додано спеціальних уроків.',
      contactAdmin: 'Зверніться до адміністратора для додавання.',
      filterByCategory: 'Фільтр за категорією',
      allCategories: 'Всі категорії',
      pickLessonAvailable: 'Оберіть урок ({{count}} доступно)',
      noLessonsInCategory: 'Немає уроків у цій категорії',
      slidesCount: '{{count}} слайдів',
      repetitionEmpty: 'Для цієї програми ще не додано уроків повторення.',
      noCustomPresentations: 'У вас ще немає власних презентацій.',
      createInPresentations: 'Створіть їх у вкладці «Презентації».',
      pickPresentationAvailable: 'Оберіть свою презентацію ({{count}} доступно)',
      customShiftHint: 'Запланований урок програми буде зсунуто вперед, як зі спецуроком.',
      withHomework: 'з ДЗ',
      cancel: 'Скасувати',
      assigning: 'Призначення...',
      assign: 'Призначити',
    },
    notes: {
      title: 'Нотатки про студентів',
      pickStudent: 'Оберіть студента для перегляду нотаток',
      addNote: 'Додати нотатку',
      placeholder: 'Напишіть нотатку...',
      loading: 'Завантаження...',
      noNotes: 'Ще немає нотаток для цього студента',
      edit: 'Редагувати',
      cancel: 'Скасувати',
      save: 'Зберегти',
      update: 'Оновити',
    },
    moduleChoice: {
      heading: 'Оберіть модуль для {{student}}',
      description: 'Далі йде модуль з альтернативами. Оберіть, який модуль краще підходить учню. Після підтвердження вибір змінити не можна.',
      confirm: 'Підтвердити вибір',
      lockedHint: 'Вибір фіксується остаточно — учень бачитиме лише уроки обраного модуля.',
      enterBlocked: 'Спершу оберіть модуль для цього учня',
      saveFailed: 'Не вдалося зберегти вибір',
    },
  },
  en: {
    students: {
      loadingStudents: 'Loading students…',
      loading: 'Loading…',
      noStudents: "You don't have any students yet.",
      searchPlaceholder: 'Search student…',
      nothingFound: 'Nothing found',
      pickStudent: 'Pick a student from the list',
      backToList: 'Back to list',
      noName: 'No name',
      noProgram: 'No program',
      ageYears: '{{age}} y.o.',
      failedToLoad: 'Failed to load',
      failedToLoadList: 'Failed to load list',
      preferences: 'Preferences',
      preferencesEmpty: "No notes yet. Add some so you remember what the student likes.",
      preferencesPlaceholder: 'What does the student like? Favorite topics, characters, games, hobbies…',
      addPreferences: 'Add',
      editPreferences: 'Edit',
      failedToSave: 'Failed to save',
      programs: 'Programs',
      noPrograms: "Student doesn't have any programs with you.",
      programStart: 'Start: {{date}} · {{done}} of {{total}} lessons completed',
      extraLessons: 'Extra lessons ({{count}})',
      noExtraLessons: 'No special, repetition or own-presentation lessons with this student yet.',
      noExtraLessonsOfType: 'No lessons of this type.',
      extraFilterAll: 'All',
      extraFilterSpecial: 'Special',
      extraFilterRepetition: 'Repetition',
      extraFilterCustom: 'Own',
      extraTypeSpecial: 'Special',
      extraTypeRepetition: 'Repetition',
      extraTypeCustom: 'Own presentation',
      extraPlanned: 'Planned',
      extraWithTeacher: 'with {{name}}',
      upcomingLessons: 'Upcoming lessons ({{count}})',
      noUpcomingLessons: 'No scheduled lessons yet.',
      showAllUpcoming: 'Show more ({{count}})',
      collapseUpcoming: 'Collapse',
      completedLessons: 'Completed lessons ({{count}})',
      noCompletedLessons: 'No completed lessons yet.',
      colDate: 'Date',
      colTopic: 'Topic',
      colProgram: 'Program',
      colStars: 'Stars',
      homeworkSection: 'Homework ({{count}})',
      noHomework: 'No homework yet.',
      colHomework: 'Homework',
      colStatus: 'Status',
      colDetails: 'Details',
      colTest: 'Test',
      colResult: 'Result',
      moduleTests: 'Module tests ({{count}})',
      noModuleTests: 'No module tests yet.',
      repetitionGames: 'Repetition games ({{count}})',
      noGames: 'No games for these programs yet.',
      lessonFallback: 'Lesson',
      lessonUnlocked: 'Unlocked',
      lessonNotPassed: 'Lesson not completed',
      homeworkFallback: 'Homework',
      lessonIndex: 'Lesson {{index}} · {{date}}',
      pointsScore: '{{score}}/{{max}} points',
      dueBy: 'due {{date}}',
      sending: 'Sending…',
      sendHomework: 'Send',
      viewShort: 'View',
      viewSubmission: 'View submission',
      failedToSendHomework: 'Failed to send homework',
      moduleTestFallback: 'Module test',
      attemptNumber: 'Attempt #{{n}}',
      passed: 'Passed',
      failed: 'Failed',
      scoreDetails: '{{score}}/{{max}} points · {{pct}}% (pass mark {{passing}}%)',
      scoreDetailsNoPct: '{{score}}/{{max}} points (pass mark {{passing}}%)',
      viewMistakes: 'View mistakes',
      attempts: '{{count}} attempts',
      statusLocked: 'Locked',
      statusAvailable: 'Unlocked',
      statusCompleted: 'Completed',
      gameTypeMemory: 'Memory',
      gameTypeLabelledDiagram: 'Labelled Diagram',
      gameTypePairOrNoPair: 'Pair or No Pair',
      gameTypeListenType: 'Listen & Type',
      gameTypeListenPickImage: 'Listen & Pick',
      gameTypeDictation: 'Dictation',
      hwStatusNotSent: 'Not sent',
      hwStatusSent: 'Sent',
      hwStatusOverdue: 'Overdue',
      hwStatusSubmitted: 'Submitted',
      hwStatusSubmittedLate: 'Submitted late',
      mtStatusNotSent: 'Not sent',
      mtStatusSent: 'Sent',
      mtStatusOverdue: 'Overdue',
      mtStatusPending: 'Not started',
      mtStatusInProgress: 'In progress',
      mtStatusSubmitted: 'Submitted',
      mtStatusSubmittedLate: 'Submitted late',
      mtStatusGraded: 'Graded',
      sendModuleTest: 'Send',
      failedToSendModuleTest: 'Failed to send module test',
      timeTaken: 'Time taken',
    },
    leavePanel: {
      title: 'Vacation & sick leave',
      submitRequest: 'Submit request',
      loading: 'Loading…',
      confirmCancel: 'Cancel this request?',
      historyTitle: 'Request history',
      noRequests: 'No requests yet.',
      cancelRequest: 'Cancel',
      vacationCard: 'Vacation',
      sickCard: 'Sick leave ({{year}})',
      forceMajeureCard: 'Force majeure (this month)',
      dayOffCard: 'Day off (this month)',
      daysUnit: 'days',
      capOf: '/ {{cap}} days',
      capOfShort: '/ {{cap}}',
      vacationDetails: 'Accrued: {{accrued}} days, used: {{used}} days.',
      firstLesson: 'First lesson: {{date}}',
      noticeDays: 'Submit at least {{days}} days in advance.',
      sickDetails: 'Used: {{used}} days this year.',
      forceMajeureDetails: 'Used: {{used}}/{{cap}} days this month. Unused days expire.',
      dayOffDetails: 'Used: {{used}}/{{cap}} day-offs this month.',
      rejectionReason: 'Rejection reason: {{reason}}',
      statusPending: 'Pending review',
      statusApproved: 'Approved',
      statusRejected: 'Rejected',
      statusCancelled: 'Cancelled',
    },
    workingHours: {
      buttonLabel: 'Working hours',
      title: 'Working hours',
      pastDate: 'Past date',
      customSchedule: 'Custom schedule',
      applyToEvery: 'Apply to every {{day}}',
      applyToAllDays: 'Apply to every day of the week',
      changesOnlyFor: 'Changes will only apply to {{date}}',
      legendAvailable: 'Non-working hours',
      legendWorking: 'Working',
      legendBusy: 'Has lesson',
      legendPast: 'Past',
      cancel: 'Cancel',
      saving: 'Saving...',
      save: 'Save',
      alertWarningTitle: 'Warning',
      alertWarningSomeFailed: 'Some changes could not be saved',
      alertSuccessTitle: 'Success',
      alertSavedAllWeeks: 'Working hours saved for every week',
      alertSavedForDate: 'Working hours saved for {{date}}',
      alertErrorTitle: 'Error',
      alertErrorSave: 'Failed to save changes',
      daySunday: 'Sunday',
      dayMonday: 'Monday',
      dayTuesday: 'Tuesday',
      dayWednesday: 'Wednesday',
      dayThursday: 'Thursday',
      dayFriday: 'Friday',
      daySaturday: 'Saturday',
      monthJan: 'January',
      monthFeb: 'February',
      monthMar: 'March',
      monthApr: 'April',
      monthMay: 'May',
      monthJun: 'June',
      monthJul: 'July',
      monthAug: 'August',
      monthSep: 'September',
      monthOct: 'October',
      monthNov: 'November',
      monthDec: 'December',
    },
    assignSpecial: {
      titleSpecial: 'Assign special lesson',
      titleRepetition: 'Assign repetition lesson',
      tabSpecial: 'Special',
      tabRepetition: 'Repetition',
      tabCustom: 'Custom',
      loading: 'Loading...',
      selectLessonError: 'Pick a lesson',
      customCategoryMissing: 'Category for custom lessons not found',
      assignError: 'Failed to assign lesson',
      specialEmpty: 'No special lessons added for this program yet.',
      contactAdmin: 'Contact the administrator to add some.',
      filterByCategory: 'Filter by category',
      allCategories: 'All categories',
      pickLessonAvailable: 'Pick a lesson ({{count}} available)',
      noLessonsInCategory: 'No lessons in this category',
      slidesCount: '{{count}} slides',
      repetitionEmpty: 'No repetition lessons added for this program yet.',
      noCustomPresentations: "You don't have any custom presentations yet.",
      createInPresentations: 'Create some in the “Presentations” tab.',
      pickPresentationAvailable: 'Pick your presentation ({{count}} available)',
      customShiftHint: 'The scheduled program lesson will be shifted forward, like with a special lesson.',
      withHomework: 'with homework',
      cancel: 'Cancel',
      assigning: 'Assigning...',
      assign: 'Assign',
    },
    notes: {
      title: 'Notes about students',
      pickStudent: 'Pick a student to view notes',
      addNote: 'Add note',
      placeholder: 'Write a note...',
      loading: 'Loading...',
      noNotes: 'No notes for this student yet',
      edit: 'Edit',
      cancel: 'Cancel',
      save: 'Save',
      update: 'Update',
    },
    moduleChoice: {
      heading: 'Pick a module for {{student}}',
      description: 'The next module has alternatives. Pick which module fits the student best. Once confirmed, the pick is final.',
      confirm: 'Confirm choice',
      lockedHint: 'This pick is locked once saved — the student sees only the lessons of the chosen module.',
      enterBlocked: 'Pick a module for this student first',
      saveFailed: 'Failed to save the choice',
    },
  },
};

export default dict;
